// Cart Free Shipping & Free Gift Progress Bars
// --------------------------------------------
// Works with snippets/cart-free-shipping.liquid and snippets/cart-free-gift.liquid
//
// Fills `.<prefix>-progress-bar-fill` based on the cart total, prints the
// remaining amount into `.<prefix>-threshold-amount`, and toggles the
// `hidden` class on `.<prefix>-threshold-no-reached` /
// `.<prefix>-threshold-reached` once the threshold is met.

(function () {
   'use strict';

   // Threshold in the shop's smallest currency unit (cents).
   const DEFAULT_THRESHOLD = 4900;

   function getThreshold(container, datasetKey) {
      const raw = container && container.dataset ? container.dataset[datasetKey] : null;
      const parsed = raw ? parseInt(raw, 10) : NaN;
      return Number.isFinite(parsed) && parsed > 0 ? parsed : DEFAULT_THRESHOLD;
   }

   function formatMoney(cents) {
      if (window.CurrencyUtils && typeof window.CurrencyUtils.formatMoney === 'function') {
         return window.CurrencyUtils.formatMoney(cents);
      }
      return (cents / 100).toFixed(2);
   }

   function updateProgressBar(prefix, datasetKey, totalPriceCents) {
      const container = document.querySelector('.' + prefix + '-container');
      if (!container) return;

      const threshold = getThreshold(container, datasetKey);
      const total = Number.isFinite(Number(totalPriceCents)) ? Number(totalPriceCents) : 0;

      const fill = container.querySelector('.' + prefix + '-progress-bar-fill');
      const amountEl = container.querySelector('.' + prefix + '-threshold-amount');
      const notReachedEl = container.querySelector('.' + prefix + '-threshold-no-reached');
      const reachedEl = container.querySelector('.' + prefix + '-threshold-reached');

      const reached = total >= threshold;
      const progress = Math.min(100, Math.max(0, (total / threshold) * 100));
      const amountLeft = Math.max(0, threshold - total);

      if (fill) fill.style.width = progress + '%';
      if (amountEl) amountEl.textContent = formatMoney(amountLeft);
      if (notReachedEl) notReachedEl.classList.toggle('hidden', reached);
      if (reachedEl) reachedEl.classList.toggle('hidden', !reached);
   }

   /**
    * Update the free shipping bar for a given cart total.
    * @param {number} totalPriceCents - Cart total in cents.
    */
   function updateFreeShippingBar(totalPriceCents) {
      updateProgressBar('free-shipping', 'freeShippingThreshold', totalPriceCents);
   }

   /**
    * Update the free gift bar for a given cart total.
    * @param {number} totalPriceCents - Cart total in cents.
    */
   function updateFreeGiftBar(totalPriceCents) {
      updateProgressBar('free-gift', 'freeGiftThreshold', totalPriceCents);
   }

   function updateAllBars(totalPriceCents) {
      updateFreeShippingBar(totalPriceCents);
      updateFreeGiftBar(totalPriceCents);
   }

   // Expose so the cart script can push totals directly on quantity changes.
   window.updateFreeShippingBar = updateFreeShippingBar;
   window.updateFreeGiftBar = updateFreeGiftBar;

   function getLocaleAwareUrl(path) {
      const localeMatch = window.location.pathname.match(/^\/([a-z]{2,3})(?:\/|$)/i);
      const reserved = ['cart', 'checkout', 'account'];
      const prefix = localeMatch && !reserved.includes(localeMatch[1].toLowerCase()) ? '/' + localeMatch[1] : '';
      return prefix + path;
   }

   async function fetchCartTotal() {
      try {
         const res = await fetch(getLocaleAwareUrl('/cart.js'), { headers: { Accept: 'application/json' } });
         if (!res.ok) return;
         const cart = await res.json();
         updateAllBars(cart.total_price);
      } catch (err) {
         /* fail silently — the bars keep their server-rendered state */
      }
   }

   function init() {
      if (!document.querySelector('.free-shipping-container, .free-gift-container')) return;
      fetchCartTotal();
   }

   if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
   } else {
      init();
   }

   // Sync with add-to-cart / notification updates fired across the site.
   document.addEventListener('cart:updated', function (event) {
      const cart = event && event.detail;
      if (cart && typeof cart.total_price === 'number') {
         updateAllBars(cart.total_price);
      } else {
         fetchCartTotal();
      }
   });
})();
